<template>
  <div class="head">
    <div class="title">
      {{title}}
    </div>
    
    <app-btn
      v-if="$store.getters['user/plan'] != 'impact'"
      class="add-fert"
      @click="$store.dispatch('fertilizers/popup/open', {open: true, isNew: true})"
    >
      {{ $ml.get(`add`) }}
    </app-btn>

  </div>
</template>

<script>
export default {
  props: {
    title: String
  }
}
</script>

<style lang="scss" scoped>
  .head {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
    // justify-content: flex-start;
    width: 100%;

    .title {
      color: #333333;
      font-size: 26px;
      line-height: 100%;
      font-weight: bold;
    }
  }
</style>
